import React from 'react'

import { useTranslation } from 'react-i18next'

import { SectionGroup, SectionItem, SectionItemValue, SectionItemListaValores } from '@/components/ui'
import type { ResumoSimulacao } from '@/features/proposta/brasil/domain/ResumoProposta/resumo-simulacoes-proposta'
import type { TPropostaSchemaInput } from '@/features/proposta/brasil/domain/schemas'

type TPropostaCompraContentVerticalProps = {
  resumo: ResumoSimulacao
  vagaIds: TPropostaSchemaInput['informacoesIniciais']['vagaIds']
  plantaDescricao: string
}

export const PropostaCompraContentVertical = ({
  resumo,
  vagaIds,
  plantaDescricao,
}: TPropostaCompraContentVerticalProps) => {
  const { t } = useTranslation('proposta')
  const vagas = vagaIds.some((v) => !v.substituiVagaPadrao) ? vagaIds.map((v) => v.descricao).join(', ') : '-'

  return (
    <React.Fragment>
      <SectionGroup withBorder>
        <SectionItem label={resumo.labelProduto} colSpan={6} withRightBorder>
          <SectionItemValue>{resumo.codigoProdutoPrincipal}</SectionItemValue>
        </SectionItem>
        <SectionItem label={t('resumo_proposta.proposta_compra.label.vaga_padrao')} colSpan={6}>
          <SectionItemValue>{vagas}</SectionItemValue>
        </SectionItem>
      </SectionGroup>

      <SectionGroup withBorder>
        <SectionItem label={t('resumo_proposta.proposta_compra.label.acessorio')}>
          <SectionItemValue>{resumo.codigosAcessorios}</SectionItemValue>
        </SectionItem>
      </SectionGroup>

      <SectionGroup withBorder>
        <SectionItem label={t('resumo_proposta.proposta_compra.label.marcacao_alvenaria')} colSpan={6} withRightBorder>
          <SectionItemValue>{resumo.dataMarcacaoAlvenaria}</SectionItemValue>
        </SectionItem>
        <SectionItem label={t('resumo_proposta.proposta_compra.label.planta')} colSpan={6}>
          <SectionItemValue>{plantaDescricao || '-'}</SectionItemValue>
        </SectionItem>
      </SectionGroup>

      <SectionGroup withBorder>
        <SectionItem label={t('resumo_proposta.proposta_compra.label.valor_total_proposta')}>
          <SectionItemValue>{resumo.valorProposta}</SectionItemValue>
        </SectionItem>
      </SectionGroup>

      <SectionGroup withBorder>
        <SectionItem label={t('resumo_proposta.proposta_compra.label.poupanca')} colSpan={6} withRightBorder>
          <SectionItemValue>{resumo.valorPoupanca}</SectionItemValue>
        </SectionItem>

        <SectionItemListaValores
          label={t('resumo_proposta.proposta_compra.label.entrada')}
          valores={resumo.entrada}
          colSpan={6}
        />
      </SectionGroup>

      <SectionGroup withBorder>
        <SectionItemListaValores
          label={t('resumo_proposta.proposta_compra.label.mensais')}
          valores={resumo.mensais}
          colSpan={6}
          withRightBorder
        />
        <SectionItemListaValores
          label={t('resumo_proposta.proposta_compra.label.intermediarias')}
          valores={resumo.intermediarias}
          colSpan={6}
        />
      </SectionGroup>

      <SectionGroup>
        <SectionItem label={t('resumo_proposta.proposta_compra.label.saldo')} colSpan={6} withRightBorder>
          <SectionItemValue>{resumo.valorSaldo}</SectionItemValue>
        </SectionItem>
        <SectionItemListaValores
          label={t('resumo_proposta.proposta_compra.label.pos_conclusao')}
          valores={resumo.posConclusao}
          colSpan={6}
        />
      </SectionGroup>
    </React.Fragment>
  )
}
